<div class="div-title">
  <h1 mat-dialog-title>Adicionar ano</h1>
</div>
<div mat-dialog-content>
  <mat-form-field appearance="outline">
    <mat-label>Ano</mat-label>
    <input matInput type="number" [(ngModel)]="data.ano" min="1" max="9999" required>
  </mat-form-field>
</div>
<div class="div-buttons" mat-dialog-actions>
  <button class="btn" mat-raised-button color="primary" [disabled]="!data.ano" (click)="confirmar()">Confirmar</button>
  <button class="btn" mat-button (click)="cancelar()">Cancelar</button>
</div>